import { ThumbsDownButton } from "./ThumbsDownButton";

export default ThumbsDownButton;
